import styled from 'styled-components';

import { ModalContainerStyle } from '../common/modal-container/modal-container-style';
import { chatIcons } from '../../assets/icons/icons';

export const ImbeeChatStyles = styled.div`
  #DIV_ID {
    height: 100%;
    iframe {
      height: 100% !important;
    }
  }

  ${ModalContainerStyle}.hide-close-button {
    top: 0px;

    .modal-navbar {
      display: none;
    }

    .modal-veil {
      height: calc(100vh);
    }

    .modal-wrapper {
      height: calc(100vh - 64px);
    }

    .modal-content {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      width: calc(100vw - 20px) !important;
      height: calc(100vh - 64px);
      border: rgba(140, 140, 140, 0.25) solid 1px;
      box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.2);
      margin: 0 10px;
      padding: 0;
    }

    .modal-children {
      flex: 1;
      overflow: hidden;
      margin-bottom: 0;
    }

    .c-chatbot__body__actions__send-button {
      border: 3px solid blue;
    }

    .modal-top {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 16px;
      margin: 0;

      h4,
      p,
      span {
        color: white;
        text-align: center;
      }
    }

    .modal-content-right {
      display: none;
    }
  }

  .c-chatbot__wrapper {
    position: fixed;
    bottom: 0;
    right: 15px;
    z-index: 1189;
    pointer-events: none;
  }

  .c-chatbot {
    border-radius: 4px 0 0 4px;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    opacity: 0;
    pointer-events: auto;
    font:
      13px/1.231 'open_sansregular',
      arial,
      sans-serif;
    color: #333;

    &.show {
      opacity: 1;
    }
  }
  .c-chatbot,
  .c-chatbot * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .c-chatbot.c-chatbot--opened {
    -webkit-box-shadow: 0 0 20px 0 rgb(111 127 134 / 40%);
    box-shadow: 0 0 20px 0 rgb(111 127 134 / 40%);
    min-width: 380px;
    max-width: 380px;
  }
  .c-chatbot:not(.c-chatbot--opened) {
    overflow: visible !important;
    height: 60px;
    width: 60px;
    margin-bottom: 120px;
    margin-right: -25px;
  }
  .c-chatbot:not(.c-chatbot--opened) .c-chatbot__head {
    position: relative;
    &::after {
      content: '';
      border-radius: 50% 0 0 50%;
      height: 50px;
      min-width: 50px;
      z-index: -1;
    }
    background-color: white;
    color: red;
    border-radius: 50% 0 0 50%;
    height: 50px;
    width: 50px;
    padding: 0;
    -webkit-box-shadow: 0 0 15px 0 rgb(111 127 134 / 40%);
    box-shadow: 0 0 15px 0 rgb(111 127 134 / 40%);
  }
  .c-chatbot.c-chatbot--opened .c-chatbot__head {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 100%;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    background: #0094d9;
    color: #fff;
  }
  .c-chatbot .c-chatbot__head {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    -webkit-transition: all 250ms ease-in-out;
    transition: all 250ms ease-in-out;
  }
  .c-chatbot.c-chatbot--opened .c-chatbot__head .c-chatbot__head__title {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 100%;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    font-size: 1.38rem;
    font-family: 'open_sanssemibold', arial, sans-serif;
    color: #fff;
    min-height: 50px;
  }
  .c-chatbot .c-chatbot__head .c-chatbot__head__title {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    text-decoration: none !important;
  }
  .c-chatbot:not(.c-chatbot--opened) .c-chatbot__head .c-chatbot__head__title {
    height: 60px;
    width: 60px;
    font-size: 0;
  }
  .c-chatbot:not(.c-chatbot--opened) .c-chatbot__head .c-chatbot__head__icon {
    font-size: 24px;
    color: #007eae;
  }
  .c-chatbot .c-chatbot__head .c-chatbot__head__buttons {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-transition: all 250ms ease-in-out;
    transition: all 250ms ease-in-out;
  }
  .c-chatbot:not(.c-chatbot--opened) .c-chatbot__head .c-chatbot__head__buttons {
    position: absolute;
    -webkit-box-orient: vertical;
    -webkit-box-direction: reverse;
    -webkit-flex-direction: column-reverse;
    -ms-flex-direction: column-reverse;
    flex-direction: column-reverse;
    right: -5px;
    bottom: calc(100% - 15px);
    opacity: 0;
    pointer-events: none;
  }
  .c-chatbot:not(.c-chatbot--opened) .c-chatbot__head .c-chatbot__head__buttons .c-chatbot__head__button {
    width: 24px;
    height: 24px;
    background: #fff;
    color: #007eae;
    border-radius: 50%;
    font-size: 12px;
    padding-top: 1px;
    margin-top: 5px;
    -webkit-box-shadow: 0 0 15px 0 rgb(111 127 134 / 40%);
    box-shadow: 0 0 15px 0 rgb(111 127 134 / 40%);
  }
  .c-chatbot:not(.c-chatbot--opened) .c-chatbot__head .c-chatbot__head__buttons .c-chatbot__head__button:last-child {
    margin-top: 0;
  }
  .c-chatbot:not(.c-chatbot--opened)
    .c-chatbot__head
    .c-chatbot__head__buttons
    .c-chatbot__head__button.c-chatbot__head__button--visible-closed {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
  .c-chatbot.c-chatbot--opened .c-chatbot__body {
    height: 620px !important;
    background-color: transparent;
  }
  .c-chatbot:not(.c-chatbot--opened) .c-chatbot__body {
    display: none;
  }
  .c-chatbot.c-chatbot--opened .c-chatbot__body {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: reverse;
    -webkit-flex-direction: column-reverse;
    -ms-flex-direction: column-reverse;
    flex-direction: column-reverse;
    -webkit-box-align: end;
    -webkit-align-items: flex-end;
    -ms-flex-align: end;
    align-items: flex-end;
    overflow: hidden;
    width: 100%;
    height: 680px;
    max-height: calc(100vh - 80px);
  }

  @media (max-width: 520px) {
    .c-chatbot {
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 9;
    }

    .c-chatbot--opened {
      bottom: unset;
      right: unset;
      top: 0;
      left: 0;
    }
    .c-chatbot__wrapper {
      bottom: unset;
      top: 0;
      left: 0;
      min-width: 0;
      width: 100%;
      height: 100vh;
    }
    .c-chatbot.c-chatbot--opened {
      min-width: 0;
      width: 100%;
      height: 100vh;
    }

    .c-chatbot.c-chatbot--opened {
      height: 100%;
      position: fixed;
      display: flex;
      flex-direction: column;
    }

    .c-chatbot:not(.c-chatbot--opened) {
      margin-bottom: 95px;
      margin-right: -35px;
    }
  }

  .c-chatbot.c-chatbot--opened .c-chatbot__head {
    flex: 0 0 50px;
    position: relative;
  }

  .c-chatbot.c-chatbot--opened .c-chatbot__body {
    flex: 1 1 auto;
    background: #fff;
  }
`;

export const companyChatProps = {
  '00000016': { icon: chatIcons['00000016'], bgCol: '#0094D9' },
  '00000001': { icon: chatIcons['00000001'], bgCol: '#DC0028' },
  '00000002': { icon: chatIcons['00000002'], bgCol: '#DC0028' },
  '00000006': { icon: chatIcons['00000006'], bgCol: '#E2001A' },
  '00000011': { icon: chatIcons['00000011'], bgCol: '#000D6E' },
  '00000010': { icon: chatIcons['00000010'], bgCol: '#003082' },
  '00000020': { icon: chatIcons['00000020'], bgCol: '#DC0028' },
  '00000025': { icon: chatIcons['00000025'], bgCol: '#004B9B' },
  '00000007': { icon: chatIcons['00000007'], bgCol: '#141476' },
  '00000060': { icon: chatIcons['00000060'], bgCol: '#007363' },
};
